import React, { useEffect, useRef } from 'react';

const TopBanner = () => {
  const bannerRef = useRef(null);

  useEffect(() => {
    const element = bannerRef.current;
    if (!element) return;

    const updateHeight = () => {
      const rect = element.getBoundingClientRect();
      const height = Math.ceil(rect.height);
      document.documentElement.style.setProperty('--top-banner-height', `${height}px`);
    };

    updateHeight();

    let resizeObserver;
    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(() => updateHeight());
      resizeObserver.observe(element);
    } else {
      window.addEventListener('resize', updateHeight);
    }

    return () => {
      if (resizeObserver) {
        resizeObserver.unobserve(element);
      } else {
        window.removeEventListener('resize', updateHeight);
      }
    };
  }, []);

  return (
    <div ref={bannerRef} className="top-banner" role="status" aria-live="polite">
      <span>
        🚀 New Response API now available! 
        <a href="/docs#responseapi" style={{ color: 'inherit', textDecoration: 'underline', marginLeft: '8px' }}>
          Learn more →
        </a>
      </span>
    </div>
  );
};

export default TopBanner;
